var _defs, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgEquaLoading = function SvgEquaLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    height: 200,
    width: 200
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "equa-loading_svg__g"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#equa-loading_svg__a",
    overflow: "visible",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "equa-loading_svg__f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#equa-loading_svg__b",
    overflow: "visible",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "equa-loading_svg__e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#equa-loading_svg__c",
    overflow: "visible",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "equa-loading_svg__h"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#equa-loading_svg__d",
    overflow: "visible",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "equa-loading_svg__a",
    d: "M0 0h1920v1080H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "equa-loading_svg__b",
    d: "M0 0h1920v1080H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "equa-loading_svg__c",
    d: "M0 0h1920v1080H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "equa-loading_svg__d",
    d: "M0 0h1920v1080H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-78.631 -239.203)",
    d: "M441.843 597.374H326.997c-30.812 0-56.022 25.21-56.022 56.021v51.822c0 1.867 1.401 3.734 3.735 3.734 1.867 0 3.735-1.4 3.735-3.734 0-26.61 21.475-48.553 48.552-48.553h63.026c30.812 0 56.022-25.21 56.022-56.022-.467-1.868-2.334-3.268-4.202-3.268",
    clipPath: "url(#equa-loading_svg__e)",
    fill: "#d5dbe0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-78.631 -239.203)",
    d: "M483.393 499.801H326.997c-30.812 0-55.555 24.743-56.022 55.555v51.821c0 1.867 1.401 3.734 3.735 3.734 1.868 0 3.735-1.4 3.735-3.734 0-26.61 21.475-48.553 48.552-48.553h104.109c30.812 0 55.555-24.743 56.022-55.556-.001-1.866-1.867-3.267-3.735-3.267",
    clipPath: "url(#equa-loading_svg__f)",
    fill: "#d5dbe0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-78.631 -239.203)",
    d: "M528.21 405.497c0 30.812-24.743 55.556-55.555 56.022H326.998c-26.611 0-48.086 21.476-48.553 48.086 0 1.868-1.867 3.735-3.735 3.735-1.867 0-3.734-1.401-3.734-3.735v-51.82c0-30.812 25.21-56.023 56.022-56.023h197.011c2.802 0 4.201 1.868 4.201 3.735",
    clipPath: "url(#equa-loading_svg__g)",
    fill: "#d5dbe0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-78.631 -239.203)",
    clipPath: "url(#equa-loading_svg__g)",
    d: "M528.21 405.497c0 30.812-24.743 55.556-55.555 56.022H326.998c-26.611 0-48.086 21.476-48.553 48.086 0 1.868-1.867 3.735-3.735 3.735-1.867 0-3.734-1.401-3.734-3.735v-51.82c0-30.812 25.21-56.023 56.022-56.023h197.011c2.802 0 4.201 1.868 4.201 3.735",
    shapeRendering: "geometricPrecision",
    fill: "#70ce45"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "1.35s",
    keyTimes: "0;0.1;0.2;0.3;0.4;1",
    values: "0;0;1;1;0;0",
    begin: "0.9s",
    attributeName: "opacity"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-78.631 -239.203)",
    clipPath: "url(#equa-loading_svg__f)",
    d: "M483.393 499.801H326.997c-30.812 0-55.555 24.743-56.022 55.555v51.821c0 1.867 1.401 3.734 3.735 3.734 1.868 0 3.735-1.4 3.735-3.734 0-26.61 21.475-48.553 48.552-48.553h104.109c30.812 0 55.555-24.743 56.022-55.556-.001-1.866-1.867-3.267-3.735-3.267",
    shapeRendering: "geometricPrecision",
    fill: "#33bb40"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "1.35s",
    keyTimes: "0;0.1;0.2;0.3;0.4;1",
    begin: "0.45s",
    values: "0;0;1;1;0;0",
    attributeName: "opacity"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-78.631 -239.203)",
    clipPath: "url(#equa-loading_svg__e)",
    d: "M441.843 597.374H326.997c-30.812 0-56.022 25.21-56.022 56.021v51.822c0 1.867 1.401 3.734 3.735 3.734 1.867 0 3.735-1.4 3.735-3.734 0-26.61 21.475-48.553 48.552-48.553h63.026c30.812 0 56.022-25.21 56.022-56.022-.467-1.868-2.334-3.268-4.202-3.268",
    shapeRendering: "geometricPrecision",
    fill: "#229f43"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "1.35s",
    keyTimes: "0;0.1;0.2;0.3;0.4;1",
    values: "0;0;1;1;0;0",
    attributeName: "opacity"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-90)",
    r: 275,
    cy: 300,
    cx: -300,
    shapeRendering: "geometricPrecision",
    fill: "none",
    stroke: "#33bb40",
    strokeWidth: 49,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: 1734,
    strokeDashoffset: 490
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "1.7s",
    keySplines: "0.3 0 0.7 1 ; 0.3 0 0.7 1",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    values: "3468;1734;0",
    attributeName: "stroke-dashoffset"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-90)",
    r: 275,
    cy: 300,
    cx: -300,
    fill: "none",
    stroke: "#33bb40",
    strokeWidth: 49,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: 1734,
    strokeDashoffset: 1733
  })));
};

export default SvgEquaLoading;